// Renders the app only when signed in AND inside a agency. Otherwise:
// - user undefined  → loading
// - user null       → SignIn
// - no agency    → CreateAgency (form or invite-only waiting room)
//
// EXCEPTION: the customer portal (/portal/*) authenticates with its own
// magic-link cookie, NOT the team's Google session. Portal visitors must
// never see the admin sign-in — the router's own PortalGate handles their
// auth. Gating on the path here (before RouterProvider mounts) is what
// makes /portal/verify?token=… work for someone with no admin account.
import type { ReactNode } from "react";
import { useAuth } from "@/state/auth";
import { SignIn } from "@/components/SignIn";
import { CreateAgency } from "@/components/CreateAgency";

export function AuthGate({ children }: { children: ReactNode }) {
  const { user, activeAgency } = useAuth();
  const path = window.location.pathname;
  if (path === "/portal" || path.startsWith("/portal/")) return <>{children}</>;

  if (user === undefined) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-background">
        <div className="animate-pulse font-display text-lg text-muted-foreground">Flowio…</div>
      </div>
    );
  }
  if (user === null) return <SignIn />;
  if (!activeAgency) return <CreateAgency />;
  return <>{children}</>;
}
